import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';

@Component({
    selector: 'view-more',
    templateUrl: './view-more.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewMoreComponent extends UiComponent {
    @Input()
    height: string = '47px';
    @Input()
    text: string = 'Lorem Ipsum';

    protected currentHeight: string = '100%';

    override ngOnInit(): void {
        super.ngOnInit();
        this.currentHeight = this.height;
    }

    protected toggle(): void {
        this.currentHeight = this.currentHeight === '100%' ? this.height : '100%';
        this.detectChanges();
    }
}
